import {
    Flex,
    FormControl,
    FormErrorMessage,
    Icon,
    Input,
    InputGroup,
    InputProps,
    InputRightElement,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { BiLockAlt } from 'react-icons/bi';

import { FormLabel } from './FormLabel';

export const FormInput = ({
    fieldName,
    label,
    placeholder,
    labelWidth,
    isRequired = false,
    isReadOnly = false,
    ...inputProps
}: {
    fieldName: string;
    label?: string;
    placeholder?: string;
    labelWidth?: string;
    isRequired?: boolean;
    isReadOnly?: boolean;
} & InputProps) => {
    const {
        register,
        formState: { errors },
    } = useFormContext();

    const { size, ...inputStyles } = inputProps;

    return (
        <FormControl
            isInvalid={!!errors[fieldName]}
            isRequired={isRequired}
            isReadOnly={isReadOnly}
            pointerEvents={isReadOnly ? 'none' : 'initial'}
        >
            <Flex direction="row" align="center">
                {label && <FormLabel fieldName={fieldName} labelWidth={labelWidth} label={label} />}
                <InputGroup size={size}>
                    <Input
                        id={fieldName}
                        variant={isReadOnly ? 'filled' : 'outline'}
                        placeholder={placeholder || '-'}
                        {...inputStyles}
                        {...register(fieldName, {
                            setValueAs: (v) => (v?.length ? v : null),
                        })}
                    />
                    {isReadOnly && (
                        <InputRightElement>
                            <Icon as={BiLockAlt} />
                        </InputRightElement>
                    )}
                </InputGroup>
            </Flex>
            {errors[fieldName] && <FormErrorMessage>{String(errors[fieldName]?.message)}</FormErrorMessage>}
        </FormControl>
    );
};
